/* eslint-disable camelcase */

import { getPageName } from '../../utils/pageName';
import { marketingStates } from '../../utils/marketingPages';
import { defaultState as queryParamsDefaultState } from '../../search/state/reducers/queryParams';
import { convertUrlParamsToSearchState } from '../../search/state/utils/convertUrlParamsToSearchState';
import { defaultState as featuresDefaultState } from '../../features/reducers/features';

export const getDefaultState = (
  url: string,
  {
    current_user = { days_remaining: 10 },
    access_premium = true,
    logged_in = false,
  },
) => {
  const queryParamsState = convertUrlParamsToSearchState(url);
  const queryParams = { ...queryParamsDefaultState, ...queryParamsState };

  const pageName = getPageName();
  const pageStates = { pageName, logged: logged_in };
  const layout = marketingStates(pageStates);

  return {
    queryParams,
    layout,
    user: {
      quotaExceeded: false,
      accessPremium: access_premium,
      /** DEPRECATED : use currentUser.status in user context instead
       * and compare with userStatusConstants */
      trialExpired: !access_premium && current_user.days_remaining === 0,
    },
    features: featuresDefaultState,
  };
};
